import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dInternal$dEffect from "../Specular.Internal.Effect/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import {documentBody} from "./foreign.js";
const runWidgetInNode = parent => widget => Specular$dDom$dBuilder.runBuilderWithUserEnv()(parent)(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBuilder.monadReplaceBuilder.newSlot)(slot => Specular$dInternal$dRIO.bindImpl((() => {
  const $0 = slot._2;
  return Specular$dInternal$dRIO.rio(env => Specular$dInternal$dEffect.pushDelayed(env.cleanup)($0));
})())(() => slot._1(widget))));
const spawnWidgetInNode = dictMonadEffect => dictMonadCleanup => node => widget => dictMonadCleanup.Monad0().Bind1().bind(dictMonadEffect.liftEffect(runWidgetInNode(node)(widget)))(v => {
  const $0 = v._1;
  return dictMonadCleanup.Monad0().Bind1().bind(dictMonadCleanup.onCleanup(v._2))(() => dictMonadCleanup.Monad0().Applicative0().pure($0));
});
const spawnWidgetInBody = dictMonadEffect => dictMonadCleanup => widget => dictMonadCleanup.Monad0().Bind1().bind(dictMonadEffect.liftEffect(documentBody))(body => spawnWidgetInNode(dictMonadEffect)(dictMonadCleanup)(body)(widget));
const runWidgetInBody = widget => () => {
  const body = documentBody();
  return runWidgetInNode(body)(widget)();
};
const runMainWidgetInNode = parent => widget => {
  const $0 = runWidgetInNode(parent)(widget);
  return () => {
    const a$p = $0();
    return a$p._1;
  };
};
const runMainWidgetInBody = widget => () => {
  const body = documentBody();
  const a$p = runWidgetInNode(body)(widget)();
  return a$p._1;
};
const monadWidget = dictMonadDomBuilder => dictMonadFRP => dictMonadReplace => dictMonoid => (
  {MonadDomBuilder0: () => dictMonadDomBuilder, MonadFRP1: () => dictMonadFRP, MonadReplace2: () => dictMonadReplace, Monoid3: () => dictMonoid}
);
const liftWidget = dictMonadDomBuilder => w => dictMonadDomBuilder.liftBuilder(env => w({parent: env.parent, cleanup: env.cleanup, userEnv: undefined}));
const emptyWidget = /* #__PURE__ */ Specular$dInternal$dRIO.pureImpl();
export {emptyWidget, liftWidget, monadWidget, runMainWidgetInBody, runMainWidgetInNode, runWidgetInBody, runWidgetInNode, spawnWidgetInBody, spawnWidgetInNode};
export * from "./foreign.js";
